import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { LocalStorageService } from '@core/services/local-storage/local-storage.service';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfig } from '../../../app.config';
import { SftpInfo } from './sftp-info.model';

@Injectable({
  providedIn: 'root',
})
export class SftpInfoService {
  ALLSFTPINFOS: SftpInfo[];
  apiBaseUrl: string;
  APIEndpoint: string;
  CurrentSftpInfoInfo$: Observable<SftpInfo>;
  CurrentSftpInfoSubject: BehaviorSubject<SftpInfo>;
  isDataChangedSubject: BehaviorSubject<boolean>;
  public isDataChanged$: Observable<boolean>;
  isidexisting$: Observable<boolean>;
  sftpinfos$: Observable<SftpInfo[]>;

  constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService,
    private toastrService: ToastrService,
    @Inject('BASE_URL') baseUrl: string
  ) {
    this.APIEndpoint =
      AppConfig.settings != undefined && AppConfig.settings
        ? AppConfig.settings.settings.apiEndpoint
        : this.localStorageService.getItem('apiEndpoint');
    this.isDataChangedSubject = new BehaviorSubject<boolean>(false);
    this.isDataChanged$ = this.isDataChangedSubject.asObservable();
  }

  addSftpInfo(client: Partial<SftpInfo>) {
    const clients = this.ALLSFTPINFOS;
    clients.push({ ...client } as SftpInfo);
  }

  AllSftpInfo(): Observable<SftpInfo[]> {
    if (this.APIEndpoint) {
      return this.http.get<SftpInfo[]>(this.APIEndpoint + 'api/SftpInfo/GetSftpInfos').pipe(
        map(data => {
          this.ALLSFTPINFOS = data;
          return data || [];
        })
      );
    }
    return of([]);
  }

  createSftp(payload: SftpInfo): Observable<SftpInfo> {
    const sftps = this.ALLSFTPINFOS;
    var id = 0;
    sftps.push({ ...payload, id } as SftpInfo);
    return this.http.post<SftpInfo>(this.APIEndpoint + 'api/SftpInfo/CreateSftp', payload).pipe(
      map(data => {
        const sftpinfos = this.ALLSFTPINFOS;
        const indexToUpdate = sftpinfos.findIndex(s => s.id === 0);
        sftpinfos[indexToUpdate].id = Number(data);
        this.toastrService.success(payload.username + ' added successfully.', 'New Sftp');
        return sftpinfos.find(sftpinfo => sftpinfo.id === Number(data));
      })
    );
  }

  deleteSftp(payload: SftpInfo) {
    return this.http.post<string>(this.APIEndpoint + 'api/SftpInfo/DeleteSftp', payload).pipe(
      map(data => {
        let d = data;
        this.toastrService.success('Sftp deleted successfully.', '');
        return data;
      })
    );
  }

  GetAllSftpInfos(): Observable<SftpInfo[]> {
    if (
      this.ALLSFTPINFOS === undefined ||
      this.ALLSFTPINFOS == null ||
      this.ALLSFTPINFOS.length == 0
    ) {
      return this.AllSftpInfo();
    }
  }

  setDataChanged(isChanged: boolean) {
    this.isDataChangedSubject.next(isChanged);
  }

  updateSftp(payload: SftpInfo): Observable<number> {
    return this.http.post<number>(this.APIEndpoint + 'api/SftpInfo/UpdateSftp', payload).pipe(
      map(data => {
        if (data <= 0) {
          this.toastrService.error('SFTP record updated Failed', 'Error');
        } else {
          this.toastrService.success(payload.hostname + ' updated successfully.', 'Edit Sftp');
        }
        const sftpinfos = this.ALLSFTPINFOS;
        const indexToUpdate = sftpinfos.findIndex(s => s.id === payload.id);
        sftpinfos[indexToUpdate] = payload;
        return indexToUpdate;
      })
    );
  }
}
